import { render } from "./RecaptchaWidget.vue?vue&type=template&id=769b5cc6"
import script from "./RecaptchaWidget.vue?vue&type=script&lang=js"
export * from "./RecaptchaWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__